var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"countdown"},[_c('div',{staticClass:"block"},[_c('div',{staticClass:"digit"},[_vm._v(" "+_vm._s(_vm.time)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }